
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic03Static as ObiHydraulic03StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-03-static.js';
 
 
 

 
 export const ObiHydraulic03Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-03-static',
   elementClass: ObiHydraulic03StaticElement,
   events: {
     
   }
  });
 
 